import {
	CHANGE_ACTIVE_GROCERY_LIST, CHANGE_CALENDAR_VIEW_MODE, CLEAR_ACTIVE_GROCERY_LIST,
	GROCERY_LIST_DRAFT_KEPT,
	GROCERY_LIST_ITEM_REORDER,
	POPULATE_VISIBLE_DATES,
	SAVE_GROCERY_LIST_BEGIN,
	SAVE_GROCERY_LIST_FAIL,
	SAVE_GROCERY_LIST_SUCCESS,
	SET_CALENDAR_DRAGGING,
	SET_COPY_ON_DRAG,
} from '../actions/calendar';
import { CHANGE_ACTIVE_BUDGET_SUCCESS } from '../actions/sharing';
import { FOOD_LEGACY_RESET } from '../actions/food';

export const calendarPageViews = {
	GROCERY_CALENDAR: 'GROCERY_CALENDAR',
	GROCERIES: 'GROCERIES',
	TRANSACTIONS: 'TRANSACTIONS',
	MEAL_IDEAS: 'MEAL_IDEAS',
	MEAL_CLEANUP: 'MEAL_CLEANUP',
};
/**
 * The calendar's UI state: the days it shows, its drag settings, and the grocery list's draft. The
 * meals, slot notes, events and grocery lists themselves are the food store's
 * (docs/local-first-food-data.md).
 */
const initialState = {
	// The id of a bought list opened in the grocery list's place, or null for the active list.
	lastSelectedGroceryList: null,
	/**
	 * The active list as it is being edited: GroceryList models kept over the food store's rows (see
	 * food/groceryListDraft.js), and a count bumped when it is changed in place, so it re-renders.
	 */
	groceryListDraft: null,
	groceryListDraftVersion: 0,

	// The first day the calendar shows, and the day after its last.
	currentStartDate: null,
	currentEndDate: null,

	savingGroceryListItems: new Set(),

	// "Copy Dragged Meals": a meal dropped on another slot is copied there rather than moved.
	copyOnDrag: false,
	// Something is being dragged, so the calendar shows its Other rows as drop targets.
	calendarDragging: false,
};

export default (state = initialState, action) => {
	switch(action.type) {
		/**
		 * Another budget: nothing of this one's may stay on screen. The days shown stay. The same when
		 * the food store moves to another budget or user by another route.
		 */
		case CHANGE_ACTIVE_BUDGET_SUCCESS:
		case FOOD_LEGACY_RESET:
			return {
				...initialState,
				currentStartDate: state.currentStartDate,
				currentEndDate: state.currentEndDate,
				copyOnDrag: state.copyOnDrag,
			};
		// Closed for good: a later fetch of the lists would otherwise open it again.
		case CHANGE_CALENDAR_VIEW_MODE:
			return {
				...state,
				lastSelectedGroceryList: null,
			};
		case CLEAR_ACTIVE_GROCERY_LIST: {
			return {
				...state,
				lastSelectedGroceryList: null,
			};
		}
		case GROCERY_LIST_DRAFT_KEPT:
			return {
				...state,
				groceryListDraft: action.payload,
				groceryListDraftVersion: state.groceryListDraftVersion + 1,
			};
		// The draft is reordered in place: its items are what is on screen and what is saved.
		case GROCERY_LIST_ITEM_REORDER: {
			const { groceryListId, startIndex, endIndex } = action.payload;
			const groceryList = state.groceryListDraft;
			if(!groceryList || groceryList.id !== groceryListId) {
				return state;
			}
			const list = [...groceryList.items];
			const [removed] = list.splice(startIndex, 1);
			list.splice(endIndex, 0, removed);
			groceryList.items = list;
			return {
				...state,
				groceryListDraftVersion: state.groceryListDraftVersion + 1,
			};
		}
		case CHANGE_ACTIVE_GROCERY_LIST:
			return {
				...state,
				lastSelectedGroceryList: Number.parseInt(action.payload) || null,
			};
		case SET_COPY_ON_DRAG:
			return {
				...state,
				copyOnDrag: action.payload,
			};
		case SET_CALENDAR_DRAGGING:
			return {
				...state,
				calendarDragging: action.payload,
			};
		case POPULATE_VISIBLE_DATES: {
			const { start, end } = action.payload;
			return {
				...state,
				currentStartDate: start,
				currentEndDate: end,
			};
		}
		case SAVE_GROCERY_LIST_BEGIN: {
			const updatedList = new Set(state.savingGroceryListItems);
			updatedList.add(action.payload);
			return {
				...state,
				savingGroceryListItems: updatedList
			};
		}
		case SAVE_GROCERY_LIST_FAIL: {
			const updatedList = new Set(state.savingGroceryListItems);
			updatedList.delete(action.payload);
			return {
				...state,
				savingGroceryListItems: updatedList,
			};
		}
		case SAVE_GROCERY_LIST_SUCCESS: {
			const { groceryList, groceryListResponse } = action.payload;
			const updatedList = new Set(state.savingGroceryListItems);
			updatedList.delete(groceryList);
			// The rows typed into the draft take their ids from the answer, by temporary_id.
			const isDraft = groceryList === state.groceryListDraft;
			if(isDraft) {
				groceryList.update({ items: groceryListResponse.items });
			}
			return {
				...state,
				savingGroceryListItems: updatedList,
				groceryListDraftVersion: state.groceryListDraftVersion + (isDraft ? 1 : 0),
			};
		}
		default:
			return state;
	}
}

